import { render, staticRenderFns } from "./zen.vue?vue&type=template&id=0b33f027&lang=pug"
import script from "./zen.vue?vue&type=script&lang=js"
export * from "./zen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Body: require('/home/docker/code/frontend/components/Body.vue').default})
